import { render } from "./StepTwo.vue?vue&type=template&id=0167db6a"
import script from "./StepTwo.vue?vue&type=script&lang=js"
export * from "./StepTwo.vue?vue&type=script&lang=js"
script.render = render

export default script